import Button from "@/components/bricks/button/Button";
import { Dialog } from "radix-ui";
import { Tabs } from "radix-ui";
import { FilterPreset } from "../../../interfaces/filters";
import FilterPresetsOverrideTab from "./FilterPresetsOverrideTab";
import FilterPresetsSaveTab from "./FilterPresetsSaveTab";
import { useState } from "react";

export default function FiltersSaveModal({
  container,
  contextType,
}: {
  container: HTMLElement | null;
  contextType: FilterPreset["type"];
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Dialog.Root open={open} onOpenChange={setOpen}>
        <Dialog.Trigger asChild>
          <Button color="secondary" transparent onClick={() => setOpen(true)}>
            Gem...
          </Button>
        </Dialog.Trigger>
        <Dialog.Portal container={container}>
          <Dialog.Overlay className="c-modal-overlay c-modal-overlay--sidebar">
            <Dialog.Content className="c-modal c-modal--sidebar">
              <Tabs.Root defaultValue="gemNytFilter">
                <Tabs.List
                  className="navbar navbar-has-tabs gap-0 p-0"
                  style={{ height: "3rem" }}
                  aria-label="Vælg hvordan du vil gemme"
                >
                  <Tabs.Trigger
                    className="tab-trigger w-50 justify-content-center"
                    value="gemNytFilter"
                  >
                    Gem nyt filter
                  </Tabs.Trigger>
                  <Tabs.Trigger
                    className="tab-trigger w-50 justify-content-center"
                    value="overskrivFilter"
                  >
                    Overskriv filter
                  </Tabs.Trigger>
                </Tabs.List>
                <FilterPresetsSaveTab
                  contextType={contextType}
                  setOpen={setOpen}
                />
                <FilterPresetsOverrideTab
                  contextType={contextType}
                  setOpen={setOpen}
                />
              </Tabs.Root>
            </Dialog.Content>
          </Dialog.Overlay>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
}
